// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("EmailVerification", {
  id: __t.u64(),
  userId: __t.u64(),
  email: __t.string(),
  tokenHash: __t.string(),
  createdAt: __t.u64(),
  expiresAt: __t.u64(),
  verified: __t.bool(),
});


